import React from 'react';
import Box from '@material-ui/core/Box';
import { CHILDREN_PROPTYPES } from 'base/constants/propTypes';

const GridContainer = ({ children, ...props }) => (
  <Box {...props} maxWidth="1284px" margin="0 auto" width="100%">
    {children}
  </Box>
);

GridContainer.propTypes = {
  children: CHILDREN_PROPTYPES
};

export default GridContainer;
